import React, { Component } from 'react';
import counterpart from 'counterpart';

import './FailedFiles.scss';

export class FailedFiles extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }


  render() {
    return (
        <div className="invalid-file-type">
          <strong>{counterpart('globalTranslate.takeAction.uploadFailed')}</strong>: {this.props.failedFile.errorMsg}
        </div>
   
    );

  }
}

export default FailedFiles;